module.exports = __webpack_public_path__ + "posture/static/img/faceBone.63cd146.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/bone/faceBone.png
// module id = Njoo
// module chunks = 1